import { render, staticRenderFns } from "./OfficerPerformance.vue?vue&type=template&id=56b162a8&scoped=true&"
import script from "./OfficerPerformance.vue?vue&type=script&lang=js&"
export * from "./OfficerPerformance.vue?vue&type=script&lang=js&"
import style0 from "./OfficerPerformance.vue?vue&type=style&index=0&id=56b162a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b162a8",
  null
  
)

export default component.exports